
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'InputModeToggle',
    emits: ['trailerHasLetters'],
    data: (): {
        hasLetters: boolean;
    } => {
        return {
            hasLetters: false,
        };
    },
    watch: {
        hasLetters(hasLetters: boolean) {
            this.$emit('trailerHasLetters', hasLetters);
        },
    },
});
